//Libraries
import React, { Component } from 'react';

import { Badge, 
    Input, InputGroup, InputGroupAddon, InputGroupText,
 } from 'reactstrap';


class TextInputComponent extends Component {


  render() {
        return(
            <div style = {{flexDirection:'row', display:'flex'}}>
                
                <div style = {{width:'100%'}}>
                <InputGroup className="mb-3">
                    {!this.props.NoIcon ? <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                            <i className="icon-info"></i>
                        </InputGroupText>
                    </InputGroupAddon> : <div/>}
                    <Input type="text" 
                        placeholder= {this.props.Title || "--"}
                        autoComplete="-" 
                        onChange = {(value) => this.props.UpdateValue(value)}
                        value = {this.props.TextValue}
                        style = {this.props.InputStyle || {color:'black'}}
                       />
                </InputGroup>
                </div>
            </div>
        )
    }
}

export default TextInputComponent